module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-point-image-3-65ca353fd858c8ab2ef1d226461ac811.png";